// extracted by mini-css-extract-plugin
module.exports = {"NotificationIndicator":"_3CFLyIPH6M9s-0I2W1MXTF"};